import { FC, useEffect, useRef, useState } from 'react';

import Filter from './Filter';
import Search from './Search';
import './index.scss';

import { isLocal, isStandaloneMode } from '../../../../../config';
import { useMedia } from '../../../../context/InterfaceContext';
import { CollectionButton } from '../collection';

import Container from '../container';

export interface ISearchFilter {
    test?: string;
}

export type SearchFilterProps = ISearchFilter;

const SearchFilter: FC<SearchFilterProps> = () => {
    const ref = useRef<HTMLInputElement>(null);
    const [scrollValue, setScrollValue] = useState(0);
    const [filterFixed, setFilterFixed] = useState(false);
    const cmsActive = document.getElementById('cms-top');
    const [topOffset, setTopOffset] = useState(200);
    const { isMobileOrTablet } = useMedia();

    useEffect(() => {
        const onScroll = (e: any) => {
            setScrollValue(e.target.documentElement.scrollTop);
        };

        window.addEventListener('scroll', onScroll);

        if (ref.current) {
            const bottomMargin = document.getElementById('bottom-margin');

            if (!filterFixed && scrollValue > topOffset) {
                ref.current.classList.add('sticky');
                setFilterFixed(true);
                if (isStandaloneMode) {
                    ref.current.style.top = '72px'; // matches Header/index.scss's fixed height
                } else if (isLocal) {
                    ref.current.style.top = '0';
                } else if (cmsActive) {
                    ref.current.style.top = isMobileOrTablet ? '102px' : '119px';
                } else {
                    ref.current.style.top = isMobileOrTablet ? '56px' : '73px';
                }

                if (bottomMargin) bottomMargin.style.marginBottom = topOffset.toString() + 'px';
            } else if (filterFixed && scrollValue < topOffset) {
                ref.current.classList.remove('sticky');
                setFilterFixed(false);
                if (bottomMargin) bottomMargin.style.marginBottom = '0';
            }
        }

        return () => window.removeEventListener('scroll', onScroll);
    }, [cmsActive, filterFixed, isMobileOrTablet, scrollValue, topOffset]);

    useEffect(() => {
        if (isStandaloneMode) {
            setTopOffset(isMobileOrTablet ? 150 : 200);
        } else if (isLocal) {
            setTopOffset(200);
        } else if (cmsActive) {
            setTopOffset(isMobileOrTablet ? 56 : 73);
        } else {
            setTopOffset(isMobileOrTablet ? 102 : 119);
        }
    }, [cmsActive, isMobileOrTablet]);

    return (
        <>
            <div ref={ref}>
                <Container classNamesContainer={'search-filter__container'}>
                    <Search classNameInput={'search-filter__search'} className={'search-filter__search'} />
                    <Filter className={'search-filter__filter'} />
                    <CollectionButton />
                </Container>
            </div>
            <div id="bottom-margin" />
        </>
    );
};

export default SearchFilter;
